import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-world-connections-modal',
  templateUrl: './add-world-connections-modal.component.html',
  styleUrls: ['./add-world-connections-modal.component.scss']
})
export class AddWorldConnectionsModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() closed: EventEmitter<string> = new EventEmitter<string>();
  @Input() countriesConnections: any;
  @Input() user: User;
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      selectedCountries: [this.countriesConnections],
      newCountryInput: [],
    })
  }

  onClose() {
    this.closed.emit();
  }
}
